export const top = 'top';
export const middle = 'middle';
export const bottom = 'bottom';
export const left = 'left';
export const center = 'center';
export const right = 'right';



// WEBPACK FOOTER //
// ./../src/Popover/Positions.js